import {
	Action,
	Dispatch,
} from 'redux';
// Import enumerations.
import {
	NotificationType
} from '@app/enumerations';
// Import action type enumeration.
import ActionType from '@app/redux/actions/types';

// Add Notification Action.

interface AddNotificationParameters {
	title: string;
	primaryMessage: string;
	secondaryMessage?: string;
	notificationType: NotificationType;
	notificationTimeout?: number;
}

type AddNotificationAction = Action & AddNotificationParameters;

const addNotificationAction: (params: AddNotificationParameters) =>
	AddNotificationAction = (params: AddNotificationParameters) => ({
	...params,
	type: ActionType.ADD_NOTIFICATION
});

const addNotification = (params: AddNotificationParameters) => 
	async (dispatch: Dispatch): Promise<void> => {
		dispatch<AddNotificationAction>(addNotificationAction(params));
	};


// Delete Notifications Action.

interface DeleteNotificationParameters {
	ids: string[];
};

type DeleteNotificationsAction = Action & DeleteNotificationParameters;

const deleteNotificationsAction: (params: DeleteNotificationParameters) =>
	DeleteNotificationsAction = (params: DeleteNotificationParameters) => ({
	...params,
	type: ActionType.DELETE_NOTIFICATIONS
});

const deleteNotifications = (params: DeleteNotificationParameters) =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch<DeleteNotificationsAction>(deleteNotificationsAction(params));	
	};


// Flush Notifications Action.

type FlushNotificationsAction = Action;

const flushNotificationsAction: () =>
	FlushNotificationsAction = () => ({
	type: ActionType.FLUSH_NOTIFICATIONS
});

const flushNotifications = () =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch<FlushNotificationsAction>(flushNotificationsAction());
	};

// Export actions.
export {
	AddNotificationAction,
	DeleteNotificationsAction,
	FlushNotificationsAction,
};

// Export action methods.
export {
	addNotification,
	deleteNotifications,
	flushNotifications,
};

// Export action parameters.
export {
	AddNotificationParameters,
	DeleteNotificationParameters
};

// Export action factories.
export {
	addNotificationAction,
	deleteNotificationsAction,
	flushNotificationsAction,
};